import { SidePanelStatus } from "@nova/component-side-panel-tab-container"
import { useAppSelector } from "integrations/redux/hooks"
import { selectUploadsForSetSummary, selectVideoJobByFlightId } from "plugins/Video/FMV/VideoSlice"
import { JobStatusType } from "@nova/constants"
import { useVideoProgress } from "plugins/Video/FMV/preview-files/VideoPreviewFiles"
import { selectUploadTimestampForFlightId } from "features/map/layers/selectors"
import { StatusAndProgressData } from "../generics/GenericLayerListItemProgress"
import { selectVideoFlightById } from "features/entity-caching/flights/selectors"

export function useVideoStatusAndProgress(id: string): StatusAndProgressData {
    const entity = useAppSelector(selectVideoFlightById(id))
    const isDemo = !!entity.demoId
    const summary = useAppSelector(selectUploadsForSetSummary(id))

    const uploadProgress = useVideoProgress(id)
    const uploadTimestamp = useAppSelector(selectUploadTimestampForFlightId(id))
    const createdAtDate = uploadTimestamp ? new Date(uploadTimestamp) : undefined

    const job = useAppSelector(selectVideoJobByFlightId(id))

    const isDone = job?.status === JobStatusType.COMPLETED

    const totalUploadCount = summary.uploadCount
    const status = isDone
        ? undefined
        : !totalUploadCount && !isDemo
          ? SidePanelStatus.empty
          : uploadProgress > 0
            ? SidePanelStatus.singleFileUploading
            : SidePanelStatus.upload

    switch (status) {
        case SidePanelStatus.singleFileUploading:
            return {
                status,
                createdAtDate,
                progress: undefined,
                totalUploadCount,
            }
    }
    return {
        status,
    }
}
